/**
 * navigation.js
 * Nav items and page titles for the GlobalOps Platform.
 * Badges reflect live counts from the data files.
 *
 * Visibility is driven entirely by role now: the Sidebar filters NAV through
 * `canSeeTab(role, id)` from src/data/roles.js. Items carry no per-item
 * access flags — add a nav id to a role's `tabs` list in roles.js to surface it.
 */

// Order follows the actual pipeline, so the sidebar reads top-to-bottom the way
// a job travels: a Lead becomes an Account, its RFQ becomes an Opportunity, and
// a won Opportunity becomes a Project, staffed from Engineers. Your own Tasks sit
// right under the Dashboard (Sharif, 9/29/26); the admin tabs sit below the run.
export const NAV = [
  { id: 'dashboard', label: 'Dashboard', icon: 'dashboard' },
  // every person's tasks in one table (T-06)
  { id: 'tasks', label: 'Tasks', icon: 'check' },
  { id: 'crm', label: 'Accounts', icon: 'crm' },
  { id: 'leads', label: 'Leads', icon: 'target' },
  // the lead KPIs for a period (D-01..D-06), right under the pipeline itself
  { id: 'leads-dashboard', label: 'Leads Dashboard', icon: 'trending' },
  { id: 'opportunities', label: 'Opportunities', icon: 'briefcase' },
  { id: 'projects', label: 'Projects', icon: 'projects' },
  { id: 'engineers', label: 'Engineers', icon: 'engineers' },
  // the parts catalog, robots by F-number and the stock we own (10/8/26),
  // right under Engineers (Sharif)
  { id: 'spare-parts', label: 'Spare Parts', icon: 'box' },
  { id: 'reporting', label: 'Reporting', icon: 'reporting' },
  // the invoice ledger, payments and receivables (10/11/26) - Operations only for now
  { id: 'finance-invoices', label: 'Finance Invoice', icon: 'invoice' },
  // Admin + operations only (roles.js); its own records, not linked to the tabs above.
  { id: 'ksa-overview', label: 'GLOBAL KSA Overview', icon: 'mappin' },
  { id: 'team', label: 'Team', icon: 'engineers' },
  { id: 'activity', label: 'Activity', icon: 'clock' },
  // every ticket sent with "Submit a ticket", to work through (10/23/26)
  { id: 'tickets', label: 'Tickets', icon: 'mail' },
  // Staffing-BD CRM — individual tabs.
  { id: 'crm-dashboard', label: 'CRM Dashboard', icon: 'dashboard' },
  { id: 'crm-accounts', label: 'CRM Accounts', icon: 'crm' },
  { id: 'crm-contacts', label: 'CRM Contacts', icon: 'engineers' },
  { id: 'crm-leads', label: 'CRM Leads', icon: 'briefcase' },
  // Engineer POV — shown only to the engineer role.
  { id: 'my-schedule', label: 'My Schedule', icon: 'engineers' },
  { id: 'my-project', label: 'My Project', icon: 'projects' },
  { id: 'daily-reports', label: 'Daily Reports', icon: 'reporting' },
  { id: 'checklists', label: 'Checklists', icon: 'checklist' },
];

export const PAGE_TITLES = {
  dashboard: 'Dashboard',
  projects: 'Projects',
  engineers: 'Engineers',
  crm: 'Accounts',
  leads: 'Leads',
  'leads-dashboard': 'Leads Dashboard',
  opportunities: 'Opportunities',
  tasks: 'Tasks',
  reporting: 'Reporting',
  'finance-invoices': 'Finance Invoice',
  'spare-parts': 'Spare Parts',
  'ksa-overview': 'GLOBAL KSA Overview',
  team: 'Team & Access',
  activity: 'Activity Log',
  tickets: 'Tickets',
  'crm-dashboard': 'CRM Dashboard',
  'crm-accounts': 'CRM Accounts',
  'crm-contacts': 'CRM Contacts',
  'crm-leads': 'CRM Leads',
  'my-schedule': 'My Schedule',
  'my-project': 'My Project',
  'daily-reports': 'Daily Reports',
  checklists: 'Checklists',
};
